// Login error codes and user-facing messages.
//
// Auth.js only forwards a small allow-list of error types to the client; any
// other exception thrown during sign-in is reported as `error=Configuration`.
// Credentials failures are therefore thrown as `CredentialsSignin` subclasses
// carrying one of these codes, which Auth.js puts on the redirect as `&code=`.

export const LOGIN_ERROR_CODES = {
    INVALID: "invalid",
    DISABLED: "disabled",
    RATE_LIMITED: "rate_limited",
} as const

export type LoginErrorCode = typeof LOGIN_ERROR_CODES[keyof typeof LOGIN_ERROR_CODES]

const INVALID_CREDENTIALS_MESSAGE = "Invalid email or password"

const CREDENTIALS_MESSAGES: Record<LoginErrorCode, string> = {
    [LOGIN_ERROR_CODES.INVALID]: INVALID_CREDENTIALS_MESSAGE,
    [LOGIN_ERROR_CODES.DISABLED]: "Account is disabled. Please contact administrator.",
    [LOGIN_ERROR_CODES.RATE_LIMITED]: "Too many login attempts. Please try again in 15 minutes.",
}

export function getLoginErrorMessage(error: string | null, code: string | null): string | null {
    if (!error) return null
    switch (error) {
        case "CredentialsSignin":
            return code && Object.hasOwn(CREDENTIALS_MESSAGES, code)
                ? CREDENTIALS_MESSAGES[code as LoginErrorCode]
                : INVALID_CREDENTIALS_MESSAGE
        case "OAuthAccountNotLinked":
            return "Account already exists with different sign-in method"
        case "AccessDenied":
            return "Access denied. Only @mushroomtravel.com emails are allowed."
        case "Configuration":
            return "Sign-in failed due to a server error. Please try again or contact administrator."
        default:
            return "Authentication failed. Please try again."
    }
}

export function isGoogleOAuthConfigured(): boolean {
    return Boolean(process.env.GOOGLE_CLIENT_ID && process.env.GOOGLE_CLIENT_SECRET)
}
